// inv/src/pages/authentication/SignUpGoogleButton.jsx
import { API_URL } from '../../config';
import { useTranslation } from 'react-i18next';
import { getStoredAttribution } from '../../service-scripts/attribution';
import googleLogo from './google-logo.svg';

function readGAFromCookiesSync() {
  const ga = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.([^.]+)\.([^.]+)/);
  const client_id = ga ? `${ga[1]}.${ga[2]}` : null;

  const ga4 = document.cookie.match(/(?:^|;\s*)_ga_[A-Z0-9]+?=GS\d\.\d\.([^.]+)\.([^.]+)/);
  const session_id = ga4 ? ga4[1] : null;
  const session_number = ga4 ? ga4[2] : null;

  return { client_id, session_id, session_number };
}

function b64urlEncode(obj) {
  const json = JSON.stringify(obj);
  const b64 = btoa(unescape(encodeURIComponent(json)));
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

const SignUpGoogleButton = () => {
  const { t, i18n } = useTranslation();

  const handleGoogleLogin = () => {
    const isTunnel = typeof window !== 'undefined' &&
      window.location.origin.includes('crprojectstaging.com');

    const apiBase = isTunnel ? 'https://api.crprojectstaging.com' : API_URL;

    const { client_id, session_id, session_number } = readGAFromCookiesSync();
    const attribution = getStoredAttribution();
    const languagePrefix = i18n.language === 'en' ? '' : `/${i18n.language}`;

    const state = b64urlEncode({
      cid: client_id || null,
      sid: session_id || null,
      sno: session_number || null,
      attr: attribution,
      src: 'signup',
      redirectBase: typeof window !== 'undefined' ? window.location.origin : null,
      redirectPath: `${languagePrefix}/app/dashboard`,
      redirectSearch: typeof window !== 'undefined' ? window.location.search : '',
    });

    window.location.assign(`${apiBase}/auth/google?state=${encodeURIComponent(state)}`);
  };

  return (
    <button
      type="button"
      onClick={handleGoogleLogin}
      className="cursor-pointer px-4 py-2 border flex gap-2 border-slate-200 rounded-lg text-slate-700 hover:border-slate-400 hover:text-slate-900 hover:shadow transition duration-150"
    >
      <img className="w-6 h-6" src={googleLogo} loading="lazy" alt="google logo" />
      <span>{t('pageSignUp.t18')}</span>
    </button>
  );
};

export default SignUpGoogleButton;
